import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Cppsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Cdowhile(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
     
      <Sides/>
       <Helmet>
 
 <title>do-while Statement in  C++  tutorial For Beginners</title>
 <meta name="description" content="C++ do-while tutorial for beginners.In do while C++ loop will always execute at least once,CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,learn code in free,c++ programming tutorial for beginners,learn code in free online,cpp do while,do while in cpp,c++ do while loop,do while loop in cpp,c++ programming do while loop,do while cpp programming,do while in c++ programming,cpp do while loop example,c++ language do while loop,do while in c++ example,cpp do while continue,cpp do while loop syntax" />
 <link rel="canonical" href="https://www.codeexampler.com/cpp-do-while" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1"> Do-while loop Statement in C++</h1>
    <div className="first">
        <a href="/cpp-while">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/cpp-for-loop">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-4 para">In do-while, C++ loop will consistently execute at least once
</p>
   


<h2 className='headings'>Syntax do while C++ loop:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code >{"\n"}
            <span className="qwerty-5">do  </span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-3">&#123; </span>
            {"\n"}{"\n"}{"    "}
            <span className="qwerty-10">statements </span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
            <span className="qwerty-5">while </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-10"> condition </span>
            <span className="qwerty-3">);</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>


<h2 className='headings'>Q-Write a program do while C++ loop example no from 1 to 10?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code >{"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
            <span className="qwerty-2">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">std; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-3">&#123; </span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">a </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-10">1 </span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-5">do </span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-3">&#123; </span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-4">cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-10">a</span>
            <span className="qwerty-3"> &#60;&#60; "</span>
            <span className="qwerty-10"> \n</span>
            <span className="qwerty-3"> ";</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-10">a </span>
            <span className="qwerty-3">++;</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-5">while </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-10"> a </span>
            <span className="qwerty-3">&#60; =</span>
            <span className="qwerty-10"> 10 </span>
            <span className="qwerty-3">);</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code >
            {"\n"}{"\n"}
              <span className="qwerty-10">1 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">2 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">3 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">4 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">5 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">6 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">7 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">8 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">9 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">10 </span>
            
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>


<h2 className='headings'>Q-Write a program decrement in C++ do-while loop no from 10 to 1?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code >{"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
            <span className="qwerty-2">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">std; </span>
            {"\n"}{"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3">&#123; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">a </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-10">10 </span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-5">do </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3">&#123; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-4">cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-10">a</span>
            <span className="qwerty-3"> &#60;&#60; "</span>
            <span className="qwerty-10"> \n</span>
            <span className="qwerty-3"> ";</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-10">a </span>
            <span className="qwerty-3">--;</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-5">while </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-10"> a </span>
            <span className="qwerty-3">&#62; =</span>
            <span className="qwerty-10"> 10 </span>
            <span className="qwerty-3">);</span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code >
            {"\n"}{"\n"}
              <span className="qwerty-10">10 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">9 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">8 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">7 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">6 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">5 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">4 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">3 </span>
              {"\n"}{"\n"} 
              <span className="qwerty-10">2 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">1 </span>
            
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>



<h1 className="mt-5">  </h1>
<div className="back">
        <a href="/cpp-while">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/cpp-for-loop">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Cdowhile;